import { injectable } from "tsyringe";
import { CountryConfigInjection } from "../../di/CountryConfigInjection";
import { CountryConfigListRequestEntity } from "../entities/CountryConfigListRequestEntity";
import { CountryConfigFormRequestEntity } from "../entities/CountryConfigFormRequestEntity";

@injectable()
export class CountryConfigUseCase {
  private repo = CountryConfigInjection.getCountryConfigRepo();

  private checkParams(params: CountryConfigListRequestEntity) {
    const { page = 0, limit = 10, ...rest } = params;
    return { page, limit, ...rest };
  }

  async getCountryConfigList(params: CountryConfigListRequestEntity) {
    return this.repo.getList(this.checkParams(params));
  }

  async getCountryConfigDetail(id: string) {
    return this.repo.getDetail({ id });
  }

  async createCountryConfig(body: CountryConfigFormRequestEntity) {
    return this.repo.create(body);
  }

  async updateCountryConfig(body: CountryConfigFormRequestEntity) {
    return this.repo.update(body);
  }

  async deleteCountryConfig(id: string) {
    return this.repo.delete({ id });
  }
}
